import * as React from 'react';
import { DevicePropsType } from '../../types';
import { MakeyourdayShowcaseBrowserStyles } from './styles';

const MakeyourdayShowcaseBrowser : React.StatelessComponent<DevicePropsType> =
  ( props : DevicePropsType ) => {
    return (
      <MakeyourdayShowcaseBrowserStyles />
    );
  };

export default MakeyourdayShowcaseBrowser;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/MakeyourdayShowcaseBrowser/MakeyourdayShowcaseBrowser.tsx